import script from "./MostPlayedSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostPlayedSection.vue?vue&type=script&setup=true&lang=ts"

import "./MostPlayedSection.vue?vue&type=style&index=0&id=4b504690&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b504690"]])

export default __exports__